import { render } from "./RatingValue.vue?vue&type=template&id=a661660c&scoped=true"
import script from "./RatingValue.vue?vue&type=script&lang=js"
export * from "./RatingValue.vue?vue&type=script&lang=js"

import "./RatingValue.vue?vue&type=style&index=0&id=a661660c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a661660c"]])

export default __exports__